import { React, useEffect, useState } from "react";
import ScmModuleStyle from '../styles/scm.module.css';
import warning from '../assets/warning.png';
import Button from '../../common/Button';
import { make_place_order, make_cancel_order } from "../services/api";
import { errorMsg } from '../../../helper/helpers';
import delivery_status_dummy from '../assets/delivery_status_dummy.PNG';

const BidsFromSupplier = ({ simObj, setSimObj, setError, getMonth, toggleSimulation, setToggleSimulation, scmPopup, setScmPopup }) => {
    const [isEnablePlaceOrder, setIsEnablePlaceOrder] = useState(true);
    const [isWaitingForBids, setIsWaitingForBids] = useState(false);
    const [bckupSimActionsObj,setBckupSimActionsObj] = useState({});
    const [mergedPlaceOrders,setMergedPlaceOrders] = useState([]);
    const [isToggledDeliveryPopup, setIsToggledDeliveryPopup] = useState(false);
    const noOfRatings = [1, 2, 3, 4, 5];
    const starRating = 2;
    const onMouseOverHandler = (event) => { 
        let left = event.currentTarget.offsetLeft + 23;
        let top = (event.currentTarget.offsetTop - (window.$(event.currentTarget.nextSibling).outerHeight() / 2) );
        window.$(event.currentTarget.nextSibling).removeAttr("style")
        window.$(event.currentTarget.nextSibling).removeClass("bottom");
        window.$(event.currentTarget.nextSibling).addClass("top left");
        window.$(event.currentTarget.nextSibling).css("left", left);
        window.$(event.currentTarget.nextSibling).css("top", top);
    }
    const getDeleveryDateAsPerOrder = (orderQuantity, weeklySupply) => {
        let unitsDelieryInFirstWeek = 0
            , remaingDaysInWeek = 0
            , deliveryItems = 0
            , date = new Date(simObj?.laststate?.stateday + " " + getMonth(simObj?.laststate?.statemonth) + " " + simObj?.laststate?.stateyear);
        remaingDaysInWeek = 7 - parseInt(date.getDay() + 1);
        let deliveryDate = date;
        for (deliveryDate = date.setDate(date.getDate() + parseInt(remaingDaysInWeek)),
            unitsDelieryInFirstWeek = weeklySupply * parseInt(remaingDaysInWeek + 1) / 7,
            deliveryItems = unitsDelieryInFirstWeek; deliveryItems + weeklySupply < orderQuantity;) {
            deliveryItems += weeklySupply;
            var newdate = new Date(deliveryDate);
            deliveryDate = newdate.setDate(newdate.getDate() + 7)
        }
        if (orderQuantity > deliveryItems) {
            var newdate = new Date(deliveryDate);
            deliveryDate = newdate.setDate(newdate.getDate() + 7)
        }
        const dateObject = new Date(deliveryDate);

        // Get the year, month, and day from the Date object
        const year = dateObject.getFullYear();
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0'); // Adding 1 because months are zero-indexed
        const day = dateObject.getDate().toString().padStart(2, '0');

        // Construct the date string in the desired format
        const formattedDateString = `${year}-${month}-${day}`;
        return console.log("delivery date after execution" + deliveryDate),
            // new Date(deliveryDate).toLocaleDateString()
            formattedDateString
    }
    const updateComponentUnits = (target, supplier) => {
        target.value = target.value.replace(/[^0-9]/g, '');
        let newActions, actions;
        let quantity = (target.getAttribute("type") == "checkbox") ? supplier.quantity : Number(target.value);
        //if (!isNaN(quantity) && quantity != 0) {
        newActions = {
            ...simObj?.actions,
            ['options']: {
                ...simObj?.actions?.options,
                ['placeOrders']: [...mergedPlaceOrders?.map((placeOrder) => {
                    let placeOrderObj
                    if (placeOrder?.supplierId == supplier?.supplierId && quantity != 0) {
                        let pqdArr = placeOrder?.priceQuantityDetailList?.filter((pqd) => quantity >= pqd.minNumberofUnits && quantity <= pqd.maxNumberofUnits)
                        placeOrderObj = {
                            ...placeOrder,
                            ['component1Unit']: simObj?.supplierDetails[supplier.supplierId]?.supplierComp1Available ? quantity : placeOrder?.component1Unit,
                            ['component2Unit']: simObj?.supplierDetails[supplier.supplierId]?.supplierComp2Available ? quantity : placeOrder?.component2Unit,
                            ['totalCost']: (pqdArr.length > 0) ? ((target.checked) ? Math.round((pqdArr[0].costPerUnit * quantity) * 1.2) : (pqdArr[0].costPerUnit * quantity)) : '',
                            ['rushOptionTaken']: target.checked,
                            ['deliveryDate']: (pqdArr.length > 0) ? target.checked ? getDeleveryDateAsPerOrder(quantity, simObj?.supplierDetails[supplier.supplierId]?.supplierExpediteUnitsPerWeek) : getDeleveryDateAsPerOrder(quantity, simObj?.supplierDetails[supplier.supplierId]?.supplierUnitsPerWeek):"",
                            ['quantity']: (pqdArr.length > 0) ? quantity : '',
                            ['rushOptionAvailable']: simObj?.supplierDetails[supplier.supplierId]?.rushOptionAvailable
                        }
                    } else if (placeOrder?.supplierId != supplier?.supplierId) {
                        placeOrderObj = {
                            ...placeOrder,
                            ['totalCost']: placeOrder?.totalCost,
                            ['deliveryDate']: placeOrder?.deliveryDate,
                            ['quantity']: placeOrder?.quantity,
                            ['rushOptionTaken']: placeOrder.rushOptionTaken,
                            ['rushOptionAvailable']: placeOrder?.rushOptionAvailable
                        }
                    } else {
                        placeOrderObj = {
                            ...placeOrder,
                            ['totalCost']: '',
                            ['deliveryDate']: '',
                            ['quantity']: '',
                            ['rushOptionTaken']: target.checked,
                            ['rushOptionAvailable']: false
                        }
                    }
                    return placeOrderObj;
                })]
            },
            ['scmDecision']: {
                ...simObj?.actions?.scmDecision,
                ["placeOrderDetails"]: []
            }
        }
        actions = {
            ...newActions,
            ['scmDecision']:
            {
                ...newActions.scmDecision,
                ['placeOrderDetails']: [
                    ...newActions.options?.placeOrders.filter((placeOrder) => (placeOrder.quantity != "" && placeOrder.quantity != undefined) && placeOrder)
                ]?.map((plOr) => ({
                    "component1Unit": plOr.component1Unit,
                    "component2Unit": plOr.component2Unit,
                    "rushOptionTaken": plOr.rushOptionTaken,
                    "supplierId": plOr.supplierId
                }))
            }
        }
        setSimObj((prevSimObj) => ({
            ...prevSimObj,
            ['actions']: actions
        }))
        setMergedPlaceOrders([...newActions.options?.placeOrders])
    }
    const makePlaceOrder = () => {
        let copySimObj = {...simObj};
        delete copySimObj.artifacts;
        delete copySimObj.graphdata;
        delete copySimObj.supplierInformations;
        delete copySimObj.supplierDetails;
        setIsEnablePlaceOrder(!isEnablePlaceOrder);
        make_place_order(copySimObj?.sessionid, copySimObj).then((response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                setError(response?.data)
            }
            else{
            if (typeof response != 'undefined') {
                setSimObj(response?.data);
                setToggleSimulation(true)
                setError(null);
            }
        }
        }).catch((error) => {
            // setError(errorMsg);
            setError({"id":"00000","msg":errorMsg})
            console.log(error);
        })
    }
    const clearPlaceOrder = () =>{
        window.$('input[type=text]').each(function(){
            window.$(this).val("");
           // window.$(this).change();
        })
        setSimObj((prevSimObj) => ({
            ...prevSimObj,
            ['actions']: bckupSimActionsObj
        }))
        setMergedPlaceOrders(bckupSimActionsObj?.options?.placeOrders);
    }
    const makeConfirmCanCelOrder = (e,supplier) => {
        if(simObj?.status=="COMPLETED"){
            e.preventDefault();
            return 
        }
        window.$('.ui.modal.cancel-order')
          .modal({
            onApprove: function() {
                setSimObj((prevSimObj) => ({
                    ...prevSimObj,
                    ["actions"]: {
                      ...simObj?.actions,
                      ["scmDecision"]: {
                        ...simObj?.actions?.scmDecision,
                        ["cancelSupplerList"]: [supplier.supplierId],
                      },
                    },
                  }));
                setToggleSimulation(true);
            }
          })
        window.$(".tiny.modal.cancel-order").modal("show");
      };

      /*Delivery date tooltip*/ 
    const handleToggleDeliveryPopup = (event) => {
        if(event === undefined){
        return;
        }
        setIsToggledDeliveryPopup(!isToggledDeliveryPopup);
    };
    
    const handleKeyDownDeliveryPopup = (event) => {
        // Toggle the button when Enter or Space is pressed
        if (event.key === 'Enter' || event.key === ' ') {
        handleToggleDeliveryPopup();
        }
    };
    window.$(document).on("click", function(e){
        if(!window.$(e.target).closest('#deliveryDatePopup').length > 0){
        setIsToggledDeliveryPopup(false);
        }
    });
    // const makeCanCelOrder = () => {
    //     make_cancel_order(simObj?.sessionid, simObj).then((response) => {
    //         if (typeof response != 'undefined') {
    //             setSimObj(response?.data);
    //             setError(null);
    //         }
    //     }).catch((error) => {
    //         setError(errorMsg);
    //         console.log(error);
    //     })
    // }
    // useEffect(() => {
    //     simObj?.actions?.scmDecision?.cancelSupplerList.length > 0 && makeCanCelOrder();
    // }, [simObj?.actions?.scmDecision?.cancelSupplerList])

    //Do not Remove below useEffect
   /* useEffect(() => {
        // Check if both viewOrderDetails and placeOrders exist
        if (simObj?.actions?.options?.viewOrderDetails && simObj?.actions?.options?.placeOrders) {
            // Merge viewOrderDetails into placeOrders
            const mergedOrders = [
                ...simObj?.actions?.options?.placeOrders,
                ...simObj?.actions?.options?.viewOrderDetails?.filter((viewOrderDetail) => viewOrderDetail.orderStatus == "INPROGRESS")
            ].filter((obj, index, self) => {
                return index === self.findIndex(innerObj => innerObj.supplierId === obj.supplierId && innerObj.orderStatus === obj.orderStatus);
            })
            // Update the state with mergedOrders
            console.log(mergedOrders);
            setSimObj((prevSimObj) => ({
                ...prevSimObj,
                actions: {
                    ...prevSimObj.actions,
                    options: {
                        ...prevSimObj.actions.options,
                        placeOrders: mergedOrders
                    }
                },
            }));
        }
    }, [simObj?.actions?.options?.viewOrderDetails]);*/

    useEffect(()=>{ 
        if (simObj?.actions?.options?.viewOrderDetails && simObj?.actions?.options?.placeOrders) {
        const mergedOrders = [
            ...simObj?.actions?.options?.placeOrders,
            ...simObj?.actions?.options?.viewOrderDetails?.filter((viewOrderDetail) => viewOrderDetail.orderStatus == "INPROGRESS")
        ].filter((obj, index, self) => {
            return index === self.findIndex(innerObj => innerObj.supplierId === obj.supplierId && innerObj.orderStatus === obj.orderStatus);
        })
        setMergedPlaceOrders([...mergedOrders]);
    }
    },[simObj?.actions?.options?.viewOrderDetails])
    useEffect(() => {
        const hasPlaceOrderDetails = simObj?.actions?.scmDecision?.placeOrderDetails?.length > 0;
        setIsEnablePlaceOrder(!hasPlaceOrderDetails);
        document.getElementById("playSumButton")?.toggleAttribute("disabled", hasPlaceOrderDetails);
      }, [simObj?.actions?.scmDecision?.placeOrderDetails]);
    useEffect(() => {
        window.$('.bidsfromsupplier .supplier_details:not([initialize="true"])').attr("initialize",true).off('click').popup({
            inline: true,
            hoverable: false,
            lastResort: 'bottom right',
            on: 'click',
            onShow: function () {
                window.$('.ui.popup').css('max-height', window.$(window).height());
            },
            //   boundary: `.scm_place-order-container__VVRLh`
        });
    }, [simObj?.supplierDetails, mergedPlaceOrders,[]])
    useEffect(()=>{ 
       (mergedPlaceOrders?.length == 0) ? setIsWaitingForBids(true) : setIsWaitingForBids(false);
       if(bckupSimActionsObj != undefined && simObj?.actions != undefined){
           Object.keys(bckupSimActionsObj)?.length == 0 && setBckupSimActionsObj(simObj?.actions);
           const updatedSimObj = { ...simObj, actions: {...simObj.actions,options: { ...simObj.actions.options,placeOrders: mergedPlaceOrders},},};
          (mergedPlaceOrders?.length != bckupSimActionsObj?.options?.placeOrders?.length) && setBckupSimActionsObj(updatedSimObj?.actions)
       }
    },[mergedPlaceOrders])
    useEffect(()=>{
        // debugger;
        (simObj?.actions?.options?.length == 0) &&  setMergedPlaceOrders([]);
        window.$(".ui.modal").modal();
      },[simObj?.actions?.options])
    return (
        <>
            <div className={`${ScmModuleStyle["bids-from-supplier"]}`}>
                {
                    (!isWaitingForBids && mergedPlaceOrders?.length > 0 ) ?
                        (<>
                            <div className={`${ScmModuleStyle["place-order-container"]}`}>
                                <table className={`ui celled table unstackable ${ScmModuleStyle["ui"]} ${ScmModuleStyle["celled"]} ${ScmModuleStyle["table"]} ${ScmModuleStyle["unstackable"]} bidsfromsupplier`} border="0" cellpadding="5" cellspacing="5">
                                    <thead>
                                        <tr>
                                            <th scope="col" colspan="2">Supplier Name</th>
                                            <th scope="col" colspan="2">Cost Per Unit </th>
                                            <th scope="col">Weekly Delivery / Rush Delivery</th>
                                            <th scope="col" style={{ "width": "70px" }}>Order Quantity</th>
                                            <th scope="col">Rush Delivery</th>
                                            <th scope="col" style={{ "width": "90px" }}>Order Cost</th>
                                            <th scope="col" style={{ "width": "90px" }}>
                                                <div className={`${ScmModuleStyle["anchor-wrapper"]}`}>
                                                    <span>Delivery Date</span>
                                                    <a id="deliveryDatePopup" className={`${ScmModuleStyle["deliveryAnchor"]}`} href="javascript:void(0)" role="button" tabIndex={0} aria-label="Info about delivery date" onClick={handleToggleDeliveryPopup} 
                                                        onKeyDown={handleKeyDownDeliveryPopup}
                                                        onMouseEnter={()=> {
                                                        if(window.innerWidth > 991) {
                                                            setIsToggledDeliveryPopup(true);
                                                        }
                                                        }}
                                                        onMouseLeave={()=> {
                                                        if(window.innerWidth > 991) {
                                                            setIsToggledDeliveryPopup(false);
                                                        }
                                                        }}
                                                        onBlur={()=> setIsToggledDeliveryPopup(false)}><img src={warning} alt="" /></a>
                                                </div>
                                                <div className={`ui fluid popup bottom center transition ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup} ${ScmModuleStyle["delivery-date-popup"]}`} style={{ display: isToggledDeliveryPopup == true ? "block" : "none" }}>
                                                    <p role="alert" aria-live="assertive">Keep an eye on the delivery date! Dates displayed in red will not finish until after your deadline.</p>
                                                </div>
                                            </th>
                                            <th scope="col" style={{ "width": "90px" }} className={`${scmPopup?.deliveryStatus ? `show ${ScmModuleStyle['show']}` : ''}`}>Delivery Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className={`${ScmModuleStyle["internal-header"]}`}>
                                            <td scope="row" colspan="9"><strong>SKU 1</strong></td>
                                            <td aria-hidden="true" className={`${scmPopup?.deliveryStatus ? `show ${ScmModuleStyle['show']}` : ''}`}></td>
                                        </tr>
                                        {
                                            mergedPlaceOrders?.length > 0 && mergedPlaceOrders?.map((supplier, index) => (
                                                simObj?.supplierDetails[supplier.supplierId]?.supplierComp1Available ? (<tr supplierid={supplier.supplierId} sender={supplier?.supplierName}>
                                                    <td scope="row" className={`${ScmModuleStyle["supplier-name"]}`} colspan="2" key={index}>
                                                        <span>{supplier?.supplierName}</span>
                                                        <a href="javascript:void(0)" onClick={onMouseOverHandler} className={`ui supplier_details ${ScmModuleStyle.ui} ${ScmModuleStyle.supplier_details}`}>
                                                            <img src={warning} alt="supplier info popup" />
                                                        </a>
                                                        <div className={`ui fluid popup top left transition hidden ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup}`} role="alert" aria-live="assertive">
                                                            <div className="ui column divided center aligned grid">
                                                                <div className={`column ${ScmModuleStyle["imgtxt"]}`}>
                                                                    <img src={`${require(`../assets/suppliers/${supplier?.supplierId}.png`)}`} alt={supplier?.supplierId} style={{ width: '60px' }} />
                                                                    <p style={{ marginTop : '0px' }}>{simObj?.supplierDetails[supplier.supplierId]?.supplierPromotion}</p></div>
                                                            </div>
                                                            <div className="ui column divided center aligned grid">
                                                                <div className={`column ${ScmModuleStyle["rating"]}`}>
                                                                    <div className={`${ScmModuleStyle["quality-star-rating"]}`}>
                                                                        <span>Quality Rating</span>
                                                                    </div>
                                                                    <ul className={`${ScmModuleStyle["rating-list"]}`}>
                                                                        {noOfRatings?.map((number, index) =>
                                                                            number <= simObj?.supplierDetails[supplier.supplierId]?.starRating ? (
                                                                                <li key={number}>
                                                                                    <span className={`fa fa-star checked ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star"]}`} />
                                                                                </li>
                                                                            ) : Number(simObj?.supplierDetails[supplier.supplierId]?.starRating) === simObj?.supplierDetails[supplier.supplierId]?.starRating &&
                                                                                simObj?.supplierDetails[supplier.supplierId]?.starRating % 1 !== 0 &&
                                                                                number <= Math.round(simObj?.supplierDetails[supplier.supplierId]?.starRating) ? (
                                                                                <li key={number}>
                                                                                    <span className={`fa fa-star-half-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-half-o"]}`} />
                                                                                </li>
                                                                            ) : (
                                                                                <li key={number}>
                                                                                    <span className={`fa fa-star-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-o"]}`} />
                                                                                </li>
                                                                            )
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td colspan="2">
                                                        <ul className={`${ScmModuleStyle["pqd"]}`}>
                                                            {
                                                                supplier?.priceQuantityDetailList?.map((pqd, index) => (
                                                                    <li key={index}>
                                                                        <span aria-hidden="true">{pqd?.minNumberofUnits} - {pqd?.maxNumberofUnits}</span>
                                                                        <span aria-hidden="true"> ${pqd?.costPerUnit} </span>
                                                                        <span className="sr-only">{`$${pqd?.costPerUnit} if the number of units is between ${pqd?.minNumberofUnits} to ${pqd?.maxNumberofUnits}`}</span>
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>
                                                    </td>
                                                    <td className={`${ScmModuleStyle["mod-value"]}`}>{simObj?.supplierDetails[supplier.supplierId]?.supplierUnitsPerWeek}&nbsp;/&nbsp;{simObj?.supplierDetails[supplier.supplierId]?.supplierExpediteUnitsPerWeek}</td>
                                                    <td>
                                                        {
                                                            supplier?.orderStatus != "INPROGRESS" ? (<input disabled={toggleSimulation || simObj?.status=="COMPLETED"} type="number" value={supplier?.quantity ?? ''} defaultValue={supplier?.component1Unit} onChange={(event) => { updateComponentUnits(event.target, supplier) }} minlength={supplier?.priceQuantityDetailList[0]?.minNumberofUnits} maxlength={supplier?.priceQuantityDetailList[supplier?.priceQuantityDetailList?.length - 1]?.maxNumberofUnits} />) : (<span>{supplier?.component1Unit}</span>)
                                                        }
                                                    </td>
                                                    <td>
                                                        <input type='checkbox' checked={supplier?.rushOptionTaken} disabled={simObj?.status=="COMPLETED" || !supplier?.rushOptionAvailable} onChange={(event) => { updateComponentUnits(event.target, supplier) }} />
                                                    </td>
                                                    <td>{supplier?.totalCost != undefined && supplier?.totalCost != "" ? "$" + Math.round(supplier?.totalCost): ''}</td>
                                                    <td style={{color: `${new Date().getFullYear()<new Date(supplier?.deliveryDate ? supplier?.deliveryDate : "").getFullYear()?"rgb(185, 0, 0)":"black"}`}}>{supplier?.deliveryDate != undefined && supplier?.deliveryDate != "" ? new Date(supplier?.deliveryDate).toLocaleDateString() : ''}</td>
                                                    <td style={{textAlign :"center"}} className={`${scmPopup?.deliveryStatus ? `show ${ScmModuleStyle['show']}` : ''}`}>
                                                        {supplier?.orderStatus === "INPROGRESS" ? (
                                                            <span><strong>In Progress</strong></span>
                                                        ) : (
                                                            <span><strong>Awaiting Order</strong></span>
                                                        )}
                                                        {
                                                            supplier?.orderStatus === "INPROGRESS" && (
                                                                <br />
                                                            )}
                                                        {supplier?.orderStatus === "INPROGRESS" && (
                                                            <span className="ui horizontal" style={{ "padding": "0.2em 0.833em" }}><a disabled={toggleSimulation} tabIndex={toggleSimulation ? -1 : ''} href="#" onClick={(e) => makeConfirmCanCelOrder(e,supplier)}>Cancel</a></span>
                                                        )}
                                                    </td>

                                                </tr>) : ''
                                            ))

                                        }
                                        <tr className={`${ScmModuleStyle["internal-header"]}`}>
                                            <td scope="row" colspan="9"><strong>SKU 2</strong></td>
                                            <td aria-hidden="true" className={`${scmPopup?.deliveryStatus ? `show ${ScmModuleStyle['show']}` : ''}`}></td>
                                        </tr>
                                        {
                                            mergedPlaceOrders?.length > 0 && mergedPlaceOrders?.map((supplier, index) => (
                                                simObj?.supplierDetails[supplier.supplierId]?.supplierComp2Available ? (<tr supplierid={supplier.supplierId} sender={supplier?.supplierName}>
                                                    <td scope="row" className={`${ScmModuleStyle["supplier-name"]}`} colspan="2" key={index}>
                                                        <span>{supplier?.supplierName}</span>
                                                        <a href="javascript:void(0)" onClick={onMouseOverHandler} className={`ui supplier_details ${ScmModuleStyle.ui} ${ScmModuleStyle.supplier_details}`}>
                                                            <img src={warning} alt="supplier info popup" />
                                                        </a>
                                                        <div className={`ui fluid popup top left transition hidden ${ScmModuleStyle.ui} ${ScmModuleStyle.fluid} ${ScmModuleStyle.popup}`} role="alert" aria-live="assertive">
                                                            <div className="ui column divided center aligned grid">
                                                                <div className={`column ${ScmModuleStyle["imgtxt"]}`}>
                                                                    <img src={`${require(`../assets/suppliers/${supplier?.supplierId}.png`)}`} alt={supplier?.supplierId} style={{ width: '60px' }} />
                                                                    <p style={{ marginTop : '0px' }}>{simObj?.supplierDetails[supplier.supplierId]?.supplierPromotion}</p></div>
                                                            </div>
                                                            <div className="ui column divided center aligned grid">
                                                                <div className={`column ${ScmModuleStyle["rating"]}`}>
                                                                    <div className={`${ScmModuleStyle["quality-star-rating"]}`}>
                                                                        <span>Quality Rating</span>
                                                                    </div>
                                                                    <ul className={`${ScmModuleStyle["rating-list"]}`}>
                                                                        {noOfRatings.map((number, index) =>
                                                                            number <= simObj?.supplierDetails[supplier.supplierId]?.starRating ? (
                                                                                <li key={number}>
                                                                                    <span className={`fa fa-star checked ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star"]}`} />
                                                                                </li>
                                                                            ) : Number(simObj?.supplierDetails[supplier.supplierId]?.starRating) === simObj?.supplierDetails[supplier.supplierId]?.starRating &&
                                                                                simObj?.supplierDetails[supplier.supplierId]?.starRating % 1 !== 0 &&
                                                                                number <= Math.round(simObj?.supplierDetails[supplier.supplierId]?.starRating) ? (
                                                                                <li key={number}>
                                                                                    <span className={`fa fa-star-half-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-half-o"]}`} />
                                                                                </li>
                                                                            ) : (
                                                                                <li key={number}>
                                                                                    <span className={`fa fa-star-o ${ScmModuleStyle["fa"]} ${ScmModuleStyle["fa-star-o"]}`} />
                                                                                </li>
                                                                            )
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td colspan="2">
                                                        <ul className={`${ScmModuleStyle["pqd"]}`}>
                                                            {
                                                                supplier?.priceQuantityDetailList?.map((pqd, index) => (
                                                                    <li key={index}>
                                                                        <span >{pqd?.minNumberofUnits} - {pqd?.maxNumberofUnits}</span>
                                                                        <span> ${pqd?.costPerUnit} </span>
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>
                                                    </td>
                                                    <td className={`${ScmModuleStyle["mod-value"]}`}>{simObj?.supplierDetails[supplier.supplierId]?.supplierUnitsPerWeek}&nbsp;/&nbsp;{simObj?.supplierDetails[supplier.supplierId]?.supplierExpediteUnitsPerWeek}</td>
                                                    <td>
                                                        {
                                                            supplier?.orderStatus != "INPROGRESS" ? (<input disabled={toggleSimulation ||  simObj?.status=="COMPLETED"} type="text" value={supplier?.quantity ?? ''} defaultValue={supplier?.component2Unit} onChange={(event) => { updateComponentUnits(event.target, supplier) }} minlength={supplier?.priceQuantityDetailList[0]?.minNumberofUnits} maxlength={supplier?.priceQuantityDetailList[supplier?.priceQuantityDetailList?.length - 1]?.maxNumberofUnits} />) : (<span>{supplier?.component2Unit}</span>)
                                                        }
                                                    </td>
                                                    <td><input type='checkbox' checked={supplier?.rushOptionTaken} disabled={simObj?.status=="COMPLETED" || !supplier?.rushOptionAvailable} onChange={(event) => { updateComponentUnits(event.target, supplier) }} /></td>
                                                    <td>{supplier?.totalCost != undefined && supplier?.totalCost != "" ? "$" + Math.round(supplier?.totalCost) : ''}</td>
                                                    <td style={{color: `${new Date().getFullYear()<new Date(supplier?.deliveryDate ? supplier?.deliveryDate : "").getFullYear()?"#B90000":"black"}`}}>{supplier?.deliveryDate != undefined && supplier?.deliveryDate != "" ? new Date(supplier?.deliveryDate).toLocaleDateString() : ''}</td>
                                                    <td style={{textAlign :"center"}} className={`${scmPopup?.deliveryStatus ? `show ${ScmModuleStyle['show']}` : ''}`}>
                                                        {supplier?.orderStatus === "INPROGRESS" ? (
                                                            <span><strong>In Progress</strong></span>
                                                        ) : (
                                                            <span><strong>Awaiting Order</strong></span>
                                                        )}
                                                        {
                                                            supplier?.orderStatus === "INPROGRESS" && (
                                                                <br />
                                                            )}
                                                        {supplier?.orderStatus === "INPROGRESS" && (
                                                            <span className="ui horizontal" style={{ "padding": "0.2em 0.833em" }}><a disabled={toggleSimulation} tabIndex={toggleSimulation ? -1 : ''} href="#" onClick={(e) => makeConfirmCanCelOrder(e,supplier)}>Cancel</a></span>
                                                        )}
                                                    </td>
                                                </tr>) : ''
                                            ))

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </>)
                        :
                        (<>
                            <div className={`${ScmModuleStyle["nobids-received"]}`} style={{ "padding": "20px 10px" }}>
                                <p> Waiting for bids.</p>
                                {/* <img src={delivery_status_dummy}/> */}
                            </div>
                        </>)
                }

            </div>
            {
               
                (mergedPlaceOrders?.length != 0) && (
                    <div className={`${ScmModuleStyle["panel2-btns"]} ${ScmModuleStyle["btn-container"]}`} style={{ marginTop : "10px", display :"flex", minHeight :"31.6px", width :"100%", justifyContent :"flex-end", marginBottom :"10px"}}>
                        <div>
                            <Button btnName="Clear"  disabled={isEnablePlaceOrder} clickEventHandler={clearPlaceOrder} btnId="clearBidsBtn" btnWidth={80} btnClass={`${ScmModuleStyle["clearBidsBtn"]}`} customBtnStyle={{ backgroundColor: "transparent", color: "rgb(178, 52, 123)", border: "1px solid rgb(178, 52, 123)", marginRight :"10px"}} />
                            <Button btnName="Place Order" disabled={isEnablePlaceOrder} clickEventHandler={makePlaceOrder} btnId="placeOrderBtn" btnWidth={140} />
                        </div>
                    </div>)
            }
        </>
    )
}

export default BidsFromSupplier
